import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import omit from 'lodash/omit';
import { FormControl } from '@cancercentrum/rcc-bootstrap';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
const tryParseDecimal = function(rawValue, numberOfDecimals) {
    let value = Number.parseFloat(rawValue && rawValue.toString().replace(',', '.'));
    if (Number.isNaN(value)) {
        value = rawValue || null;
    } else if (numberOfDecimals) {
        value = Math.round(value * 10 ** numberOfDecimals) / 10.0 ** numberOfDecimals;
    }
    return value;
};
const RegvarDecimal = (props)=>{
    const { id, readOnly, regvarMetadata, inputRef, step, type = 'text', ...otherProps } = props;
    const { min, max, ...rest } = otherProps;
    const [value, setValue] = useState(props.value ?? null);
    const val = useRegvarValidator();
    useEffect(()=>{
        setValue(props.value ?? null);
    }, [
        props.value
    ]);
    const onChange = (e)=>{
        setValue(e.target.value);
    };
    const onBlur = (e)=>{
        const parse = props.valueParser || ((x)=>x);
        const newValue = parse(tryParseDecimal(e.target.value, regvarMetadata.precision));
        props.onChange(newValue);
        setValue(newValue);
    };
    const inputStep = 1 / Math.pow(10, regvarMetadata.precision);
    let inputValue = value;
    if (typeof inputValue === 'number') {
        inputValue = inputValue.toFixed(regvarMetadata.precision).replace('.', ',');
    } else {
        inputValue = inputValue || '';
    }
    if (readOnly) {
        return /*#__PURE__*/ _jsx("div", {
            className: "form-control-plaintext",
            children: inputValue
        });
    }
    const minVal = Object.prototype.hasOwnProperty.call(props, 'min') ? min : regvarMetadata.min;
    const maxVal = Object.prototype.hasOwnProperty.call(props, 'max') ? max : regvarMetadata.max;
    return /*#__PURE__*/ _jsx(FormControl, {
        ...omit(rest, val.getValidationPropNames([
            'required',
            'min',
            'max'
        ]), 'valueParser'),
        id: id,
        min: minVal ?? undefined,
        max: maxVal ?? undefined,
        step: Object.prototype.hasOwnProperty.call(props, 'step') ? step : inputStep,
        value: inputValue,
        onChange: onChange,
        onBlur: onBlur,
        ref: inputRef,
        type: type
    });
};
export default /*#__PURE__*/ memo(RegvarDecimal);
